interface ChainAddress {
    [key: string]: string
}

export const unlockAddresses : ChainAddress = {
    1: "0x3d5409cce1d45233de1d4ebdee74b8e004abdd13",
    4: "0xD8C88BE5e8EB88E38E6ff5cE186d764676012B0b"
}

export const networkNames : ChainAddress = {
    1: "Ethereum Mainnet",
    5: "Goerli Testnet"
}